<template>
  <div class="pt-16">
    <div class="bg-gradient-to-r from-purple-600 to-indigo-600 lg:pb-0 lg:z-10 lg:relative">
      <div class="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-3 lg:gap-8">
        <div class="relative lg:-my-8">
          <div
            aria-hidden="true"
            class="absolute inset-x-0 top-0 h-1/2 bg-white lg:hidden" />
          <div class="mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:p-0 lg:h-full">
            <div class="aspect-w-10 aspect-h-6 rounded-xl shadow-xl overflow-hidden sm:aspect-w-16 sm:aspect-h-7 lg:aspect-none lg:h-full">
              <img
                class="object-cover lg:h-full lg:w-full"
                src="https://images.unsplash.com/photo-1520333789090-1afc82db536a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2102&q=80"
                alt="">
            </div>
          </div>
        </div>
        <div class="mt-12 lg:m-0 lg:col-span-2 lg:pl-8">
          <div class="mx-auto max-w-md px-4 sm:max-w-2xl sm:px-6 lg:px-0 lg:py-20 lg:max-w-none">
            <blockquote>
              <div>
                <svg
                  class="h-12 w-12 text-white opacity-25"
                  fill="currentColor"
                  viewBox="0 0 32 32"
                  aria-hidden="true">
                  <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
                </svg>
                <p class="mt-6 text-2xl font-medium text-white">
                  This platform is currently in closed beta, which means only select customers can register.
                  Please get in touch if you would like to know more about our services!
                </p>
              </div>
              <footer class="mt-6">
                <p class="text-base font-medium text-white">
                  Stig Selås
                </p>
                <p class="text-base font-medium text-cyan-100">
                  CEO at Traveloffice AS
                </p>
              </footer>
            </blockquote>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="bg-gray-50 pb-10">
    <div class="py-8 flex flex-col-reverse justify-center max-w-5xl mx-auto md:flex-row">
      <div class="hidden mx-auto flex pt-12 pb-8 lg:pt-32 flex-grow md:block">
        <nav
          aria-label="Progress"
          class="w-52">
          <ol
            role="list"
            class="overflow-hidden">
            <li
              v-for="(step, stepIdx) in steps"
              :key="step.name"
              :class="[stepIdx !== steps.length - 1 ? 'pb-10' : '', 'relative']">
              <template v-if="step.step < this.step">
                <div
                  v-if="(stepIdx !== steps.length - 1)"
                  class="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full bg-indigo-600"
                  aria-hidden="true" />
                <div
                  class="relative flex items-start group cursor-pointer"
                  @click="this.step = step.step">
                  <span class="h-9 flex items-center">
                    <span class="relative z-10 w-8 h-8 flex items-center justify-center bg-indigo-600 rounded-full group-hover:bg-indigo-800">
                      <CheckIcon
                        class="w-5 h-5 text-white"
                        aria-hidden="true" />
                    </span>
                  </span>
                  <span class="ml-4 min-w-0 flex flex-col">
                    <span class="text-xs font-semibold tracking-wide uppercase">{{ step.name }}</span>
                    <span class="text-sm text-gray-500">{{ step.description }}</span>
                  </span>
                </div>
              </template>
              <template v-else-if="step.step === this.step">
                <div
                  v-if="(stepIdx !== steps.length - 1)"
                  class="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full bg-gray-300"
                  aria-hidden="true" />
                <div
                  class="relative flex items-start group"
                  aria-current="step">
                  <span
                    class="h-9 flex items-center"
                    aria-hidden="true">
                    <span class="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-indigo-600 rounded-full">
                      <span class="h-2.5 w-2.5 bg-indigo-600 rounded-full" />
                    </span>
                  </span>
                  <span class="ml-4 min-w-0 flex flex-col">
                    <span class="text-xs font-semibold tracking-wide uppercase text-indigo-600">{{ step.name }}</span>
                    <span class="text-sm text-gray-500">{{ step.description }}</span>
                  </span>
                </div>
              </template>
              <template v-else>
                <div
                  v-if="(stepIdx !== steps.length - 1)"
                  class="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full bg-gray-300"
                  aria-hidden="true" />
                <div class="relative flex items-start group">
                  <span
                    class="h-9 flex items-center"
                    aria-hidden="true">
                    <span class="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full group-hover:border-gray-400">
                      <span class="h-2.5 w-2.5 bg-transparent rounded-full group-hover:bg-gray-300" />
                    </span>
                  </span>
                  <span class="ml-4 min-w-0 flex flex-col">
                    <span class="text-xs font-semibold tracking-wide uppercase text-gray-500">{{ step.name }}</span>
                    <span class="text-sm text-gray-500">{{ step.description }}</span>
                  </span>
                </div>
              </template>
            </li>
          </ol>
        </nav>
      </div>

      <div class="mx-auto w-full mx-auto pt-16 pb-8 px-4 sm:px-6 lg:pt-32 lg:px-8">
        <div class="p-4 bg-white h-full shadow-lg sm:rounded-md sm:overflow-hidden sm:p-6">
          <h2 class="text-lg font-semibold text-gray-700">
            {{ steps[step-1].name }}
          </h2>
          <p class="mt-0 mb-6 text-gray-700">
            {{ steps[step-1].description }}
          </p>

          <!-- This example requires Tailwind CSS v2.0+ -->
          <div
            v-if="form.hasErrors"
            class="rounded-md bg-red-50 p-4 my-6">
            <div class="flex">
              <div class="flex-shrink-0">
                <!-- Heroicon name: solid/x-circle -->
                <svg
                  class="h-5 w-5 text-red-400"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true">
                  <path
                    fill-rule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                    clip-rule="evenodd" />
                </svg>
              </div>
              <div class="ml-3">
                <h3 class="text-sm font-medium text-red-800">
                  There were {{ Object.keys(form.errors).length }} errors with your submission
                </h3>
                <div class="mt-2 text-sm text-red-700">
                  <ul
                    role="list"
                    class="list-disc pl-5 space-y-1">
                    <li v-for="(error, attr) in form.errors">
                      {{ error }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <section
            v-if="step === 1"
            class="mb-20">
            <CreateAccount :form="form" />
          </section>

          <section
            v-if="step === 2"
            class="mb-36">
            <Services
              :form="form"
              :account-types="accountTypes" />
          </section>

          <section
            v-if="step === 3"
            class="mb-16">
            <AccountOption
              :form="form"
              :account-options="accountOptions" />
            <Country
              :form="form"
              :countries="countries"
              class="mt-4" />
          </section>

          <div class="flex items-center w-full">
            <div
              v-if="step === steps.length"
              class="flex justify-start w-2/3">
              <div class="flex items-center">
                <jet-checkbox
                  id="terms"
                  v-model:checked="form.terms"
                  name="terms"
                  class="cursor-pointer" />
                <div class="ml-2 cursor-default">
                  I agree to the
                  <a
                    class="underline text-gray-600 hover:text-gray-900 cursor-pointer"
                    @click="showTermsAndConditions = !showTermsAndConditions">
                    Terms and Conditions.
                  </a>
                </div>
              </div>
            </div>
            <div class="flex items-center w-full justify-end">
              <Link
                :href="route('login')"
                class="underline text-sm text-gray-600 hover:text-gray-900 mr-4">
                Already registered?
              </Link>
              <jet-button
                v-if="step !== 1"
                type="button"
                class="flex items-center mr-4 justify-center bg-gradient-to-r from-purple-600 to-indigo-600 bg-origin-border px-4 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white hover:from-purple-700 hover:to-indigo-700"
                :class="{ 'opacity-25': form.processing }"
                :disabled="form.processing"
                @click.prevent="previousStep">
                Back
              </jet-button>
              <jet-button
                v-if="step !== steps.length"
                type="button"
                class="flex items-center justify-center bg-gradient-to-r from-purple-600 to-indigo-600 bg-origin-border px-4 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white hover:from-purple-700 hover:to-indigo-700"
                :class="{ 'opacity-25': form.processing }"
                :disabled="form.processing"
                @click.prevent="nextStep">
                Next
              </jet-button>
              <jet-button
                v-if="step === steps.length"
                :disabled="isDisabled"
                type="submit"
                class="flex items-center justify-center bg-gradient-to-r from-purple-600 to-indigo-600 bg-origin-border px-4 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white hover:from-purple-700 hover:to-indigo-700"
                :class="{ 'opacity-25': form.processing }"
                @click.prevent="submit">
                Register
              </jet-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="relative bg-gradient-to-r from-gray-600 to-indigo-700">
    <div class="relative h-56 bg-indigo-600 sm:h-72 md:absolute md:left-0 md:h-full md:w-1/2">
      <img
        class="w-full h-full object-cover"
        src="https://images.unsplash.com/photo-1525130413817-d45c1d127c42?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1920&q=60&sat=-100"
        alt="">
      <div
        aria-hidden="true"
        class="absolute inset-0 bg-gradient-to-r from-teal-500 to-cyan-600 mix-blend-multiply" />
    </div>
    <div class="relative mx-auto max-w-md px-4 py-12 sm:max-w-7xl sm:px-6 sm:py-20 md:py-28 lg:px-8 lg:py-32">
      <div class="md:ml-auto md:w-1/2 md:pl-10">
        <h2 class="text-base font-semibold uppercase tracking-wider text-gray-300">
          Award winning support
        </h2>
        <p class="mt-2 text-white text-3xl font-extrabold tracking-tight sm:text-4xl">
          We’re here to help
        </p>
        <p class="mt-3 text-lg text-gray-300">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Et, egestas tempus tellus etiam sed. Quam a scelerisque amet ullamcorper eu enim et fermentum, augue. Aliquet amet volutpat quisque ut interdum tincidunt duis.
        </p>
        <div class="mt-8">
          <div class="inline-flex rounded-md shadow">
            <a
              :href="route('operators')"
              target="_blank"
              class="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-gray-900 bg-white hover:bg-gray-50">
              Visit the help center
              <!-- Heroicon name: solid/external-link -->
              <svg
                class="-mr-1 ml-3 h-5 w-5 text-gray-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true">
                <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
                <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <TermsAndConditions
    :show="showTermsAndConditions"
    :account-type="form.accountType === 'guide' ? accountTypes[1] : accountTypes[0]"
    @close="showTermsAndConditions = false" />
</template>

<script>
import { CheckIcon } from '@heroicons/vue/24/solid';
import { Link } from '@inertiajs/vue3';
import JetCheckbox from '../../Jetstream/Checkbox.vue';
import JetButton from '../../Jetstream/Button.vue';
import LandingLayout from '../../Layouts/LandingLayout.vue';
import AccountOption from '../../ComponentsDeprecated/Steps/AccountOption.vue';
import CreateAccount from '../../ComponentsDeprecated/Steps/CreateAccount.vue';
import Country from '../../ComponentsDeprecated/Steps/Country.vue';
import Services from '../../ComponentsDeprecated/Steps/Services.vue';
import TermsAndConditions from '../../ComponentsDeprecated/Modal/TermsAndConditions.vue';

const accountTypes = [
  {
    id: 'operator', title: 'Tour Operator', description: 'For tour operators providing organized travel',
  },
  {
    id: 'guide', title: 'Tour Guide', description: 'For tour guides and tour leaders looking to organize their calendar and find tour engagements in their area',
  },
];
const accountOptions = [
  {
    id: 'personal', title: 'Personal Team',
  },
  {
    id: 'organization', title: 'Create an Organization',
  },
];

const countries = [
  { id: 'Norway' },
  { id: 'Sweden' },
];

const steps = [
  {
    name: 'Account',
    description: 'E-mail and password',
    step: 1,
  },
  {
    name: 'Services',
    description: 'Choose service',
    step: 2,
  },
  {
    name: 'Team',
    description: 'Organization or personal',
    step: 3,
  },
];

export default {
  components: {
    Services,
    CreateAccount,
    AccountOption,
    JetButton,
    JetCheckbox,
    TermsAndConditions,
    CheckIcon,
    Country,
    Link,
  },

  layout: LandingLayout,

  props: {
    type: {
      type: String,
      required: false,
      default: null,
    },
  },

  setup() {
    return {
      accountTypes,
      countries,
      accountOptions,
      steps,
    };
  },

  data() {
    return {
      showTermsAndConditions: false,
      form: this.$inertia.form({
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        password_confirmation: '',
        accountType: this.type === 'guide' ? accountTypes[1].id : accountTypes[0].id,
        accountOption: accountOptions[0].id,
        country: countries[0].id,
        terms: false,
        team: {
          name: '',
          org_no: '',
          address: '',
          zip: '',
          city: '',
          status: null,
        },
      }),

      step: this.steps[0].step,
    };
  },

  computed: {
    isDisabled() {
      return !this.form.terms;
    },
  },

  methods: {
    submit() {
      this.form.post(this.route('register'), {
        onFinish: () => this.form.reset('password', 'password_confirmation'),
      });
    },

    nextStep() {
      this.step++;
    },

    previousStep() {
      this.step--;
    },
  },
};
</script>
